module.exports = __webpack_public_path__ + "static/media/arrow.793a8392.svg";